import { render, staticRenderFns } from "./uploadDocumentTemplate.vue?vue&type=template&id=28ebab10&scoped=true"
import script from "./uploadDocumentTemplate.vue?vue&type=script&lang=js"
export * from "./uploadDocumentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ebab10",
  null
  
)

export default component.exports